import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const BASE_URL = process.env.REACT_APP_API_URL || 'https://code.mannaplag.mannaanalytics.com/api';


export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async () => {
    if (!email.trim()) { setError('Please enter your email address.'); return; }
    setLoading(true);
    setError('');
    try {
      const res = await fetch(`${BASE_URL}/auth/forgot-password/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim().toLowerCase() }),
      });
        const data = await res.json();
    if (!res.ok) {
      setError(data.message || "Failed to send reset link.");
      return;
    }
      setSent(true);
    } catch {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="w-full max-w-sm">

        {/* Logo */}
        <div className="flex flex-col items-center mb-8">
          <img src="/manna-plag-logo-horizontal.png?v=2" alt="Manna Plag" className="mb-3" style={{ height: 48, objectFit: "contain" }} />
        </div>

        <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-8">
          {sent ? (
            <div className="text-center">
              <div className="w-14 h-14 rounded-lg bg-green-50 flex items-center justify-center mx-auto mb-4">
                <svg width="28" height="28" fill="none" viewBox="0 0 24 24" stroke="#22c55e" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <h2 className="text-[18px] font-black text-gray-900 mb-2">Check your email</h2>
              <p className="text-[13px] text-gray-500 leading-relaxed mb-6">
                If <strong>{email}</strong> is registered, you'll receive a password reset link shortly. Check your spam folder if you don't see it.
              </p>
              <Link to="/login" className="text-[13px] font-bold text-navy hover:underline" style={{ color: '#003c6c' }}>
                ← Back to login
              </Link>
            </div>
          ) : (
            <>
              <h2 className="text-[20px] font-black text-gray-900 mb-1">Forgot your password?</h2>
              <p className="text-[13px] text-gray-400 mb-6">Enter your email and we'll send you a reset link.</p>

              <div className="flex flex-col gap-4">
                <div>
                  <label className="text-[11px] font-bold text-gray-500 uppercase tracking-wide block mb-1.5">Email address</label>
                  <input
                    type="email"
                    value={email}
                    onChange={e => { setEmail(e.target.value); setError(''); }}
                    onKeyDown={e => e.key === 'Enter' && handleSubmit()}
                    placeholder="you@example.com"
                    className="w-full border border-gray-200 rounded-xl px-4 py-3 text-[13px] font-medium text-gray-900 outline-none focus:border-indigo-400 focus:ring-2 focus:ring-indigo-100 transition-all"
                  />
                </div>

                {error && (
                  <p className="text-[12px] text-red-500 font-medium bg-red-50 px-4 py-3 rounded-xl">{error}</p>
                )}

                <button
                  onClick={handleSubmit}
                  disabled={loading}
                  className="w-full py-3 bg-navy text-white text-[13px] font-black rounded-md border border-navy hover:bg-white hover:text-navy hover:border-navy transition-all duration-200 disabled:opacity-60 uppercase tracking-tight mt-1"
                >
                  {loading ? 'Sending...' : 'Send reset link'}
                </button>

                <Link to="/login" className="text-center text-[12px] font-bold text-gray-400 hover:text-gray-600 transition-colors">
                  ← Back to login
                </Link>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
